module.exports = __webpack_public_path__ + "img/vue-crud-md.ee509a0d.png";